"use strict";
/* eslint-disable max-classes-per-file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessResult = exports.FailureResult = exports.Result = void 0;
class Result {
    static success(successValue) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return new SuccessResult(successValue);
    }
    static failure(failureValue) {
        return new FailureResult(failureValue);
    }
    isSuccess() {
        return this instanceof SuccessResult;
    }
}
exports.Result = Result;
// eslint-disable-next-line sort-exports/sort-exports
class FailureResult extends Result {
    constructor(value) {
        super();
        this.value = value;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    get data() {
        return this.value;
    }
}
exports.FailureResult = FailureResult;
class SuccessResult extends Result {
    constructor(value) {
        super();
        this.value = value;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    get data() {
        return this.value;
    }
}
exports.SuccessResult = SuccessResult;
